import { defineMessages } from "react-intl";

const howDidYouHearModalMessages = defineMessages({
  tv: {
    id: "hosting.how_did_you_hear_options.tv",
    defaultMessage: "TV",
  },
  billboard: {
    id: "hosting.how_did_you_hear_options.billboard",
    defaultMessage: "Billboard",
  },
  mailOrFlyer: {
    id: "hosting.how_did_you_hear_options.mail_or_flyer",
    defaultMessage: "Mail or flyer",
  },
  onlineSearch: {
    id: "hosting.how_did_you_hear_options.online_search",
    defaultMessage: "Online search",
  },
  newsOrArticles: {
    id: "hosting.how_did_you_hear_options.news_blog_article",
    defaultMessage: "News or blog article",
  },
  onlineAd: {
    id: "hosting.how_did_you_hear_options.online_ad",
    defaultMessage: "Online ad",
  },
  friend: {
    id: "hosting.how_did_you_hear_options.friend_family_colleague",
    defaultMessage: "Friend, family, or colleague",
  },
  social: {
    id: "hosting.how_did_you_hear_options.social_media",
    defaultMessage: "Social media",
  },
  event: {
    id: "hosting.how_did_you_hear_options.attended_peerspace_event",
    defaultMessage: "Attended an event in a Peerspace",
  },
  contacted: {
    id: "hosting.how_did_you_hear_options.contacted_by_peerspace",
    defaultMessage: "Contacted by Peerspace",
  },
  referral: {
    id: "hosting.how_did_you_hear_options.referral_from_host",
    defaultMessage: "Referral from a Peerspace host",
  },
});


export {howDidYouHearModalMessages}